module.exports = __webpack_public_path__ + "static/media/footer-bg.61e61976.png";